import React, { useState, useEffect } from 'react';
import { Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import Main_Page from './mainPage';
import Home from './Home';
import ViewTilesQuote from './ViewTilesQuote';
import ItemsforQuote from './ItemsforSO';
import ConsumerLogin from './ConsumerLogin';
import OTPpage from './OTPpage';
import AddUserDetails from './AddUserDetails';
import NotApproved from './NotApproved';
import AddProject from './AddProject';
import ProjectDetails from './ProjectDetails';
import ViewProject from './ViewProject';   
import ProductDetails from './ProductDetails';
import CartPreview from './CartPreview';
import OrderDetails from './OrderDetails';
 import DoorsQuote from './DoorsQuote';
// import WindowsQuoteDetails from './WindowsquoteDetails';

//import MaterialReq from './MaterialReq';
import ViewWiendowDetailsQuote from './ViewQuotationDetails';
import ViewQuotationDetails from './ViewQuotationDetails';
import WindowSummary from './WindowSummary';
import QuotationSummary from './QuotationSummary';
import DoorSummary from './DoorSummary';
import DoorQuotationSummary from './DoorQuotationSummary';
import TilesOrderSummary from './TilesOrderSummary';


 import ViewWindowsQuote from './ViewQuotationDetails';
 import MaterialRequirement from './MaterialRequirement';
 import MaterialReq from './MaterialReq';
 import MaterialReq2 from './MaterialReq2';
 import QuotationDetails from './QuotationDetails';
import WindowsQuotationDetails from './WindowsQuotationDetails';
import WindowsEconomyQuote from './WindowQuote';
 import DoorQuotationDetails from './DoorQuotationDetails';
import TilesQuote from './TilesQuote';
import WindowQuote from './WindowQuote';
import QuoteSummary from './TilesQuoteSummary';
import DoorsQuoteSummary from './DoorsQuoteSummary'
import WindowsQuotationSummary from './WindowsQuoteSummary';
import SummaryPage from './SummaryPage';
import TilesStandardQuoteDetails from './Tiles/TilesStandardQuoteDetails';
import TilesCustomize from './Tiles/TilesCustomize';
import WindowsStandardQuoteDetails from './Windows/WindowsStandardQuoteDetails';
import WindowsCustomize from './Windows/WindowsCustomize';
import DoorsStandardQuoteDetails from './Doors/DoorsStandardQuoteDetails';
import DoorsCustomize from './Doors/DoorsCustomize';
import Proceed from './Proceed';
import Approved from './Approved';
import Projects from './Projects';
import ProfileAccount from './ProfileAccount';
import Orders from './Orders';
import RoleSelection from './RoleSelection';
import Buildcoins from './Buildcoins';
import ProductInformation from './ProductInformation';
import AddAddress from './AddAddress';
import PaymentMethod from './PaymentMethod';
import Upipayments from './UpiPayments';
import ProductList from './ProductList';
import ProductSubcateoryProductsList from './productSubcategoryProductsList';
import ProductCategories from './ProductCategories';
import Vendoritems from './Vendoritems';
import TrackItems from './TrackItems';
import RFQ from './RFQ';
import ProjectQuote from './ProjectQuote';
import ListPage from './ListPage';
import BuildcoinsTrn from './BuildcoinsTransactions';
import UMR from './UMR';
import ProjectQuoteModal from './ProjectQuoteModal';
//import RFQList from './Journey/RFQList';
import MaterialList from './Journey/MaterialList';
import ReviewItemList from './Journey/ReviewItemList';
import UserDashboard from './UserDashboard';

import ProjectQuotes from './Journey/ProjectQuotes';
import RFQDetails from './RFQS/RFQ_details';
import RFQList from './RFQS/RFQ_List';
import SavedItems from './SavedItems';
/* import MidOrderScreen from './/OrderDetailsSample/MidProcessScreen'; */
//import usePageTracking from '../usePageTracking';

import CustomerOrderDetails from './Orders/order_details';
//import SampleRFQDetails from './RFQS/sample_rfq_details';
 
function App() {

  const navigate = useNavigate();
const location = useLocation();

useEffect(() => {
  const publicPaths = [
    "/consumer", 
    "/consumer/otp",
    "/consumer/UserDetails",
    "/consumer/NotApproved",
    "/consumer/approved"
  ];

  const isPublic = publicPaths.includes(location.pathname);

  const sessionUser = sessionStorage.getItem("userData");
  const localUser = localStorage.getItem("userData");

  // NOT LOGGED IN → trying to open a consumer protected page
  if (!isPublic && location.pathname.startsWith("/consumer")) {
    if (!sessionUser && !localUser) {
      navigate("/consumer", { replace: true });
    }
  }
}, [location.pathname, navigate]);

/*   const [appId, setappId] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const BrickBucket = () => {
      if (location.pathname.startsWith('/measurit_v1.0')) {
        const storedLoginData = JSON.parse(localStorage.getItem('LoginData'));
        if (storedLoginData) {
          const appId = storedLoginData.appId;
        setappId(appId);
        setLoading(false);
        } else {
          // Handle case where user data is not available
          // For example, navigate to login page
          if (location.pathname.startsWith('/measurit_v1.0') && 
          !location.pathname.startsWith('/measurit_v1.0/reset-password') &&
          !location.pathname.startsWith('/measurit_v1.0/forgot-password') &&
          !location.pathname.startsWith('/measurit_v1.0/reset-password')
      ) {
          navigate('/measurit_v1.0/adminhome');
          setLoading(false);
      }
          
        }
      }
    };

    BrickBucket(); // Call BrickBucket function directly here
  }, [navigate, location.pathname]); // Add navigate and location.pathname as dependencies
 */

  /* if (loading) {
    return <div>Loading...</div>;
  } */

/*   const AccessDenied = () => {
    return (
      <div
        className="fixed inset-0 bg-gray-500/50 flex justify-center items-center"
        style={{ backdropFilter: 'blur(100px)' }}
        role="dialog"
        aria-modal="true"
      >
<div className="bg-white rounded shadow-md p-8 max-w-md">
  <h2 className="text-lg font-bold text-center">Access Denied</h2>
  <p className="text-gray-600 text-center">You do not have permission to access this page.</p>
  <div className="flex justify-center mt-2">
    <button
      className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-1 px-1 rounded"
      onClick={() => {
        sessionStorage.clear();
        localStorage.clear();
        navigate('/bb');
      }}
    >
      Go Back
    </button>
  </div>
</div>
      </div>
    );
  }; */

 /*  const loginData = JSON.parse(localStorage.getItem('userData'));
  const userId = loginData ? loginData._id : null;
  usePageTracking(userId); // This will track the page view based on the current pat */

  


  return (
    <Routes>
       {/* <Route path="/bb" element={<Login />} /> */}

       <Route path='/consumer' element={<ConsumerLogin />} />
       <Route path='/consumer/otp' element={<OTPpage />} />
       <Route path='/consumer/UserDetails' element={<AddUserDetails/>}/>
       <Route path='/consumer/NotApproved' element={<NotApproved/>}/>
       <Route path ='/consumer/approved' element = {<Approved/>}/>
       <Route path='/consumer/addproject' element={<AddProject/>}/>
       <Route path = '/consumer/projectdetails' element = {<ProjectDetails/>}/>
       <Route path ='/consumer/viewproject' element = {<ViewProject/>}/>
       <Route path='/consumer/productdetails' element = {<ProductDetails/>}/>
       <Route path='/consumer/cartpreview' element={<CartPreview/>}/>
       <Route path='/consumer/projects' element={<Projects/>}/>
       <Route path='/consumer/profileaccount' element={<ProfileAccount/>}/>
       <Route path='/consumer/userdashboard' element={<UserDashboard/>}/>
       <Route path='/consumer/orders' element={<Orders/>}/>
       <Route path='consumer/roleselection' element={<RoleSelection />} />
       <Route path='consumer/buildcoins' element={<Buildcoins />} />
       <Route path='consumer/bctrn' element={<BuildcoinsTrn />} />
      <Route path='consumer/productinformation' element ={<ProductInformation />} />
      <Route path='consumer/addaddress' element ={<AddAddress/>} />
      <Route path='consumer/PaymentMethod' element = {<PaymentMethod/>} />
      <Route path='consumer/upipayments' element = {<Upipayments/>} /> 
      <Route path='/consumer/productlist' element={<ProductSubcateoryProductsList />} /> 
      <Route path='/consumer/productcategories' element={<ProductCategories />} />
      <Route path='/consumer/vendoritems' element={<Vendoritems/>} />
      <Route path='/consumer/rfq' element={<RFQ/>} />
      <Route path ='/consumer/trackitems' element= {<TrackItems/>} />
      <Route path ='/consumer/projectquote' element= {<ProjectQuote/>} />
      <Route path = '/consumer/umr' element= {<UMR/>} />
      <Route path ='projectquotemodal' element ={<ProjectQuoteModal/>} />
      <Route path = '/consumer/listpage' element= {<ListPage/>} />
      <Route path='/consumer/saveditems' element = {<SavedItems/>}/>
     <Route path="/consumer/app" element={<Main_Page />}>
       <Route path='home' element = {<Home/>}/> 
       <Route path='materialrequirement' element={<MaterialRequirement/>} />
       <Route path='materialreq' element={<MaterialReq/>} />
       <Route path='materialreq2' element={<MaterialReq2/>} />
       <Route path='tilesquote' element={<TilesQuote/>} />
       <Route path='viewtilesquote' element = {<ViewTilesQuote/>}/>
       <Route path='itemsforso' element = {<ItemsforQuote/>} />
         <Route path='doorsquote' element = {<DoorsQuote/>} /> 
           <Route path='viewquotationdetails' element={<ViewQuotationDetails/>}/>
           <Route path='windowquote' element = {<WindowQuote/>} />
        {/* <Route path='windowsQuoteDetails' element = {<WindowsQuoteDetails/>} />  */}
        <Route path='windowsummary' element = {<WindowSummary/>} />
        <Route path='quotationsummary' element = {<QuotationSummary/>} />
        <Route path='doorsummary' element= {<DoorSummary/>} />
        <Route path='doorquotationsummary' element= {<DoorQuotationSummary/>} />
        <Route path='tilesordersummary' element = {<TilesOrderSummary/>} />
        <Route path='MaterialReq' element = {<MaterialReq/>} />
        <Route path='quotationdetails' element = {<QuotationDetails/>} />
        <Route path='doorsQuotationDetails' element = {<DoorQuotationDetails/>} />
        <Route path='windowsquotationdetails' element = {<WindowsQuotationDetails />} />
        <Route path='quotesummary' element = {<QuoteSummary/>}/>
        <Route path='doorsquotesummary' element = {<DoorsQuoteSummary/>}/>
        <Route path='windowsquotesummary' element = {<WindowsQuotationSummary/>}/>
        <Route path = 'summarydetails' element = {<SummaryPage/>}/>
        <Route path='tilesstandardquotedetails' element = {<TilesStandardQuoteDetails/>}/>
        <Route path='tilescustomize' element = {<TilesCustomize/>}/>
        <Route path='windowsstandardquotedetails' element = {<WindowsStandardQuoteDetails/>}/>
        <Route path='windowscustomize' element = {<WindowsCustomize/>}/>
        <Route path='doorsstandardquotedetails' element = {<DoorsStandardQuoteDetails/>}/>
        <Route path='doorscustomize' element = {<DoorsCustomize/>}/>
        <Route path='proceed' element = {<Proceed/>}/>
        {/* <Route path='orderdetails' element = {<OrderDetails/>}/> */}
        <Route path='materiallist' element ={<MaterialList/>}/>
        <Route path='reviewitemlist' element ={<ReviewItemList/>}/>
        <Route path='projectquotes' element = {<ProjectQuotes/>}/>

       {/*  <Route path='orderdetails3' element = {<MidOrderScreen/>}/> */}
       <Route path='rfqlist' element = {<RFQList/>}/>
       <Route path = 'rfqdetails'element = {<RFQDetails/>}/>
       <Route path='orderdetails' element={<CustomerOrderDetails/>}/>
       {/* <Route path='preview' element = {<SampleRFQDetails/>}/>
 */}
      </Route>
   
    </Routes>
  );
}

export default App;
